import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import elementZhTwLocale from 'element-ui/lib/locale/lang/zh-TW'// element-ui lang
import enLocale from './en'
import zhLocale from './zh'
import zhTwLocale from './zh_tw'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale
  },
   zh_tw: {
    ...zhTwLocale,
    ...elementZhTwLocale
  }
}

const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: Cookies.get('language') || 'zh',
  silentTranslationWarn:true,//没有的key值不发出警告
  missing(locale,key, vm){//没有key值时应如何处理  
  	return key.replace('menu.','')  //处理左边菜单问题
  },
  // set locale messages
  messages
})

export default i18n
